import { createApiRef, DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export interface TestNotificationRequest {
  title: string;
  description: string;
  link: string;
}

export interface TestNotificationsApi {
  sendTestNotification(request: TestNotificationRequest): Promise<void>;
}

export const testNotificationsApiRef = createApiRef<TestNotificationsApi>({
  id: 'plugin.test-notifications.service',
});

export class TestNotificationsClient implements TestNotificationsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async sendTestNotification(request: TestNotificationRequest): Promise<void> {
    const baseUrl = await this.discoveryApi.getBaseUrl('test-notifications');
    const response = await this.fetchApi.fetch(`${baseUrl}/test-notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error(`Failed to send test notification: ${response.statusText}`);
    }
  }
}
